// @flow
import { Record } from "immutable"

import type { Action, ReducerState } from "../records/PropTypes"
import type { ExtrasId } from "mmb/types/primitiveTypes"
import {
  SET_CARD_TYPE_ACTION,
  SET_MOBILE_SUMMARY_VISIBILITY,
  SET_SERVICE_ID_FOR_PAYMENT,
  SUBMIT_FOR_PAYMENT,
} from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingPayment/records/consts"
import { RELOAD_SUCCESS } from "mmb/scenes/AccountBooking/components/Booking/services/consts"

type SetCardType = {|
  type: typeof SET_CARD_TYPE_ACTION,
  payload: string,
|}

export const serviceForPayment = new Record({
  category: "",
  payload: {},
})

export const InitialState = new Record({
  isMobileSummaryVisible: false,
  serviceForPayment: new serviceForPayment(),
  serviceIdForPayment: null,
  cardType: null,
})

export default (state: ReducerState = new InitialState(), action: Action): ReducerState => {
  if (!(state instanceof InitialState)) return new InitialState()
  switch (action.type) {
    case SET_MOBILE_SUMMARY_VISIBILITY:
      return state.set("isMobileSummaryVisible", action.payload.state)
    case SET_SERVICE_ID_FOR_PAYMENT:
      return state.set("serviceIdForPayment", action.serviceIdForPayment)
    case SUBMIT_FOR_PAYMENT:
      return state.set("serviceForPayment", {
        category: action.category,
        useBalance: action.useBalance,
        price: action.price,
        margin: action.margin,
        currency: action.currency,
        orderAction: action.orderAction,
        payload: action.payload,
      })
    case RELOAD_SUCCESS:
      return new InitialState()
    case SET_CARD_TYPE_ACTION:
      return state.set("cardType", action.payload)
    default:
      return state
  }
}

export const setCardType = (cardType: string): SetCardType => ({
  type: SET_CARD_TYPE_ACTION,
  payload: cardType,
})

export const setServiceIdForPaymentAction = (serviceIdForPayment: ExtrasId) => ({
  type: SET_SERVICE_ID_FOR_PAYMENT,
  serviceIdForPayment,
})
